export const QRY_SIMPLE_COUP_INFO = '/app/promotion/prom_qry_simplecoup_info.cgi';
export const QRY_CHAIN_COUP_INFO = '/app/promotion/prom_qry_combincoup_info.cgi';
export const USER_COUPON_LIST = '/app/coupon/prom_user_coupon_list.cgi';
export const QRY_PRIZE_INFO = '/app/usershare/prom_qry_prize_info.cgi';
export const QRY_COUPON_INFO = '/app/promotion/prom_qry_coupon_info.cgi';
export const QRY_COUPON_DETAIL = '/app/promotion/prom_qry_usercoupon_detail.cgi';
export const PROM_SHOW_GOODS_INFO = '/app/promotion/prom_show_goods_info.cgi';
